import { MarkerTypeWaterActivity } from 'types/markerTypes/location-markers-type.js';
import { MarineMarkerLocationTypeCustom } from 'types/markerTypes/markers.waterActivityMarine';
import { CellStatusRating } from 'utilities/buildTables/cell-build-data/buildDataStatus.js';
import { predicateObject } from 'utilities/isType.js';
import { regionTitleCase } from 'utilities/text/titleCase.js';

const isNameKeyofObj = <T extends object>(name: string, value: T) => {
  const enumKeys = Object.keys(value);
  if (enumKeys.includes(name)) {
    return name as keyof T;
  }
  return undefined;
};

export const getMarineWeatherRisk = (
  marineMarker: typeof MarkerTypeWaterActivity.Paddleboarding | typeof MarkerTypeWaterActivity.Kayak,
  value: MarineMarkerLocationTypeCustom['value'],
): CellStatusRating => {
  const pprop = `weatherRisk${regionTitleCase([marineMarker])}`;
  const val = isNameKeyofObj(pprop, value);
  const result1 = val ? value[val] : {};
  const result2 = predicateObject(result1) ? result1 : {};
  return result2;
};
